import { calendarDate, clockTime } from 'utils/eventContract'
import React, { useEffect } from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import styled from 'styled-components' 
import Modal from '@mui/material/Modal';  
import { useSelector, useDispatch } from 'react-redux' 
import { getEvents, setViewEventModal, setViewCalendarItemInfoModal, setViewAddCalendarItemModal } from 'features/events/eventSlice'
import LoaderSmall from 'loaders/LoaderSmall' 
import { setViewSidebar, setEventItem } from 'features/sidebar/sidebarSlice' 

const localizer = momentLocalizer(moment)

export default function CalendarComponent() {

    const dispatch = useDispatch()

    const { user, admin } = useSelector(state => state.auth)
    const { eventsList, calendarItems, isEventLoading, createCalendarItemStatus } = useSelector(state => state.events)
    const { profileChurch } = useSelector(state => state.profileChurch)
    const [list, setDates] = React.useState([])
    
    const handleSelectEvent = (event) => { 
        dispatch(setViewSidebar("events"))
        dispatch(setEventItem({
            name: event.title,
            start: event.start,
            end: event.end,
            color: event.color
        }))
    }

    const handleCreateCalendarItem = () => {
        dispatch(setViewAddCalendarItemModal(true)) 
    }

    const handleInfoClick = () => { 
        dispatch(setViewCalendarItemInfoModal(true)) 
    }

    const handleSelectSlot = (event) => {

        if(!admin[profileChurch._id] && !user.isOrganization){
            return
        }else{
            dispatch(setViewEventModal({  
                // startDate: event.start,  
            }))         
        }
    }

    useEffect(() => {
        if(eventsList.length === 0){ 

            dispatch(getEvents({
                ids: profileChurch._id
            }))
        }
    }, [])

    let setDatesFunction = () => {
        let dates = []

        eventsList.map((event, index) => {
            const start = event.startDate.split('-')
            const end = event.endDate ? event.endDate.split('-') : null 

            dates.push({
                id: index,
                title: event.eventName,
                allDay: !event.startTime,
                start: new Date(calendarDate(event.startDate) + 'T' + (clockTime(event.startTime) || '00:00')),
                end: new Date(calendarDate(event.endDate || event.startDate) + 'T' + (clockTime(event.endTime || event.startTime) || '23:59')),
                color: event.color           
            })      
        })
        setDates(dates)
    }
    
    useEffect(() => {
        if(eventsList.length > 0){
            setDatesFunction()
        }

        if(calendarItems.length > 0){ 
            calendarItems.forEach((item, index) => { 
                item.ongoingDates.forEach((date, index) => {
                    let starDate = date.date.slice(0, date.date.indexOf('T')) + 'T' + date.startTime                    
                    let  endDate = date.date.slice(0, date.date.indexOf('T')) + 'T' + date.endTime
                    setDates(prev => [...prev, {
                        id: starDate,
                        title: item.eventName,
                        allDay: false, 
                        start: moment(starDate).toDate(),
                        end: moment(endDate).toDate(),
                        color: item.color
                    }])
                })
            })
        }
    }, [eventsList, calendarItems, createCalendarItemStatus ])


      const eventStyleGetter = (event) => {
        const backgroundColor = event.color;
        return {
            style: { backgroundColor, borderRadius: '5px', opacity: 0.8, color: 'white', border: '0px',  display: 'block',
        },
        };
    };



    return (
        <CalendarContainer>  
            <Calendar
                localizer={localizer}
                events={list}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500, backgroundColor: 'white', padding: '10px', borderRadius: '10px' }}
                onSelectEvent={handleSelectEvent}
                onSelectSlot={handleSelectSlot}
                eventPropGetter={eventStyleGetter}
                selectable
                
                />
{/* 
            <Tooltip title="Sync Calendar"> 
                <SyncCalendar> 
                    < SyncIcon /> 
                </SyncCalendar>
            </Tooltip> */}

            <Modal
                open={isEventLoading}
                onClose={() => {}}
                style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                >
                
                <LoaderSmall />
                
            </Modal> 
        </CalendarContainer>
    )
}

const CalendarContainer = styled.div`  
    margin-top: 30px;
    width: 100%;
    padding: 10px;

`
